export function DefaultEditorial() {
  return (
    <div className="typography-text-extra-small text-muted-foreground">
      <p className="font-bold">NerdWallet is committed to editorial integrity</p>
      <p>
        Many or all of the products featured here are from our partners who compensate us. This
        influences which products we write about and where and how the product appears on a page.
        However, this does not influence our evaluations. Our opinions are our own. Here is a{' '}
        <a
          href="https://www.nerdwallet.com/p/our-partners"
          className="text-secondary-foreground no-underline hover:underline"
        >
          list of our partners
        </a>{' '}
        and here&apos;s{' '}
        <a
          href="https://www.nerdwallet.com/p/advertiser-disclosure"
          className="text-secondary-foreground no-underline hover:underline"
        >
          how we make money
        </a>
        .
      </p>
    </div>
  );
}
